import script from "./JobsPageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./JobsPageComponent.vue?vue&type=script&setup=true&lang=js"

import "./JobsPageComponent.vue?vue&type=style&index=0&id=586bc580&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-586bc580"]])

export default __exports__